export default __webpack_public_path__ + "static/media/230b3c63-b497-421b-ae7d-182024bef8ac.2f1b2317.eot";